module.exports = __webpack_public_path__ + "static/0046-52f7c13e9baca3fd8530ef72a19fe7cd.png";